import { IconProps } from "../../utils/global-types/global-types";

const RunningIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_628_22021)">
        <path
          fill="currentColor"
          d="M9 1.5C4.864 1.5 1.5 4.865 1.5 9s3.364 7.5 7.5 7.5 7.5-3.365 7.5-7.5S13.136 1.5 9 1.5m2.982 7.763-4.375 2.812a.312.312 0 0 1-.482-.262V6.187a.312.312 0 0 1 .482-.262l4.375 2.812a.313.313 0 0 1 0 .526"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_628_22021">
          <path fill="#fff" d="M1.5 1.5h15v15h-15z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default RunningIcon;
